import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { StatusResponse } from '../models/status-response.model';
import { Payment } from '../models/payment.model';
import { SecureHttp } from '../helpers/securehttp';
import { environment } from '../../environments/environment';

@Injectable()
export class PaymentsService {

  private _quarterlyPayment = new BehaviorSubject<number | null>(null);

  public quarterlyPayment$ = this._quarterlyPayment.asObservable();

   private _annualPayment = new BehaviorSubject<number | null>(null);

  public annualPayment$ = this._annualPayment.asObservable();

  constructor(
    private _secureHttp: SecureHttp,
  ) {}

  setQuarterlyPayment(amount: number): void {
    this._quarterlyPayment.next(amount);
  }

  setAnnualPayment(amount: number): void {
    this._annualPayment.next(amount);
  }

  clearQuarterlyPayment(): void {
    this._quarterlyPayment.next(null);
  }

  clearAnnualPayment(): void {
    this._annualPayment.next(null);
  }

  getCurrentQuarterlyPayment(): number | null {
    return this._quarterlyPayment.getValue();
  }

  getCurrentAnnualPayment(): number | null {
    return this._annualPayment.getValue();
  }

  getPayment(account: string, id: string): Observable<Payment> {
    let url = `${environment.apiUrl}api/payments`;
    let params = new HttpParams().set('account', account).set('id', id);
    return this._secureHttp.get(url, { params }).pipe(map(response => response as Payment));
  }

  getPendingPayment(account: string, requestId: string): Observable<Payment> {
    let url = `${environment.apiUrl}api/payments/pending`;
    let params = new HttpParams().set('account', account).set('requestId', requestId);
    return this._secureHttp.get(url, { params }).pipe(map(response => response as Payment));
  }

  submitPayment(account: string, payment: Payment, save?: boolean): Observable<StatusResponse> {
    let url = `${environment.apiUrl}api/payments`;
    let params = new HttpParams().set('account', account).set('save', save ? 'true' : 'false');
    return this._secureHttp.post(url, payment, { params }).pipe(map(response => response as StatusResponse));
  }

  cancelPayment(requestId: string, account: string): Observable<StatusResponse> {
    let url = `${environment.apiUrl}api/payments`;
    let params = new HttpParams().set('requestId', requestId).set('account', account);
    return this._secureHttp.delete(url, { params }).pipe(map(response => response as StatusResponse));
  }

  choosePaymentPlan(opportunityId: number, paymentPlanId: number): Observable<StatusResponse> {
    const url = `${environment.apiUrl}api/surplus-lines/opportunities/${opportunityId}/payment-plans/${paymentPlanId}`;
    const params = new HttpParams().set('opportunityId', opportunityId).set('paymentPlanId', paymentPlanId);
    return this._secureHttp.get(url, { params }).pipe(map(response => response as StatusResponse));
  }

  getPaymentPlan(opportunityId: number): Observable<Payment> {
    const url = `${environment.apiUrl}api/surplus-lines/opportunities/${opportunityId}/installment-plan`;
    const params = new HttpParams().set('opportunityId', opportunityId);
    return this._secureHttp.get(url, { params }).pipe(map(response => response as Payment));
  }
}
